const emojis = [
  { native: 'ᵃ', previewWithX: true },
  { native: 'ᵇ', previewWithX: true },
  { native: 'ᶜ', previewWithX: true },
  { native: 'ᵈ', previewWithX: true },
  { native: 'ᵉ', previewWithX: true },
  { native: 'ᶠ', previewWithX: true },
  { native: 'ᵍ', previewWithX: true },
  { native: 'ʰ', previewWithX: true },
  { native: 'ⁱ', previewWithX: true },
  { native: 'ʲ', previewWithX: true },
  { native: 'ᵏ', previewWithX: true },
  { native: 'ˡ', previewWithX: true },
  { native: 'ᵐ', previewWithX: true },
  { native: 'ⁿ', previewWithX: true },
  { native: 'ᵒ', previewWithX: true },
  { native: 'ᵖ', previewWithX: true },
  { native: 'ʳ', previewWithX: true },
  { native: 'ˢ', previewWithX: true },
  { native: 'ᵗ', previewWithX: true },
  { native: 'ᵘ', previewWithX: true },
  { native: 'ᵛ', previewWithX: true },
  { native: 'ʷ', previewWithX: true },
  { native: 'ˣ', previewWithX: true },
  { native: 'ʸ', previewWithX: true },
  { native: 'ᶻ', previewWithX: true },
  { native: '⁰', previewWithX: true },
  { native: '¹', previewWithX: true },
  { native: '²', previewWithX: true },
  { native: '³', previewWithX: true },
  { native: '⁴', previewWithX: true },
  { native: '⁵', previewWithX: true },
  { native: '⁶', previewWithX: true },
  { native: '⁷', previewWithX: true },
  { native: '⁸', previewWithX: true },
  { native: '⁹', previewWithX: true },
  { native: '⁺', previewWithX: true },
  { native: '⁻', previewWithX: true },
  { native: '⁼', previewWithX: true },
  { native: '⁽', previewWithX: true },
  { native: '⁾', previewWithX: true },
  { native: '₀', previewWithX: true },
  { native: '₁', previewWithX: true },
  { native: '₂', previewWithX: true },
  { native: '₃', previewWithX: true },
  { native: '₄', previewWithX: true },
  { native: '₅', previewWithX: true },
  { native: '₆', previewWithX: true },
  { native: '₇', previewWithX: true },
  { native: '₈', previewWithX: true },
  { native: '₉', previewWithX: true },
  { native: '₊', previewWithX: true },
  { native: '₋', previewWithX: true },
  { native: '₌', previewWithX: true },
  { native: '₍', previewWithX: true },
  { native: '₎', previewWithX: true },
  { native: '⅐', previewWithX: false },
  { native: '⅑', previewWithX: false },
  { native: '⅒', previewWithX: false },
  { native: '⅓', previewWithX: false },
  { native: '⅔', previewWithX: false },
  { native: '⅕', previewWithX: false },
  { native: '⅖', previewWithX: false },
  { native: '⅗', previewWithX: false },
  { native: '⅘', previewWithX: false },
  { native: '⅙', previewWithX: false },
  { native: '⅚', previewWithX: false },
  { native: '⅛', previewWithX: false },
  { native: '⅜', previewWithX: false },
  { native: '⅝', previewWithX: false },
  { native: '⅞', previewWithX: false },
  { native: '↉', previewWithX: false }
];

export default emojis;
